export const mockPushNotifications = {
  pushNotificationsAllowed: ref(false),
  pushNotificationsRecipientId: ref<string | undefined>(),
  pushNotificationsSubscriptionId: ref<string | undefined>(),
  pushNotificationsOnboarding: async () => {
    // do nothing
  },
  subscribePushNotification: (_comparisonInfo: ComparisonInfo) => {
    // do nothing
  },
}
